import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Input } from 'antd';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import moment from "moment";

function Dashboard() {

    const navigate = useNavigate();
    const [liveChartData, setLiveChartData] = useState([]);
    const [backupChartData, setBackupChartData] = useState([]);
    const options = {
        title: {
            text: 'Backup Sports Profit',
        },
        series: [
            {
                type: 'pie',
                data: backupChartData,
            },
        ],
    };

    const optionsLive = {
        title: {
            text: 'Live Sports Profit',
        },
        series: [
            {
                type: 'pie',
                data: liveChartData,
            },
        ],
    };


    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px] lg:px-[17px] ' >
                <div className='col-span-12 lg:col-span-6 px-[16px] lg:px-[13px]'>
                    <div className='mb-[1.5rem] w-full'>
                        <div className='font-bold text-[0.938rem] leading-[23px] bg-[linear-gradient(#022c43,_#18b0c8)] px-[10px] py-[5px] text-[#ffffff] rounded-tl-[calc(.25rem-1px)] rounded-br-[0] rounded-tr-[calc(.25rem-1px)] rounded-bl-[0]'>
                            Live Sports Profit
                        </div>
                        <div className='p-[0px flex-auto] w-full border-[1px] border-[#0000002d] bg-[#ffffff] flex items-center justify-center'>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={optionsLive}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-span-12 lg:col-span-6 px-[16px] lg:px-[13px]  '>
                    <div className='mb-[1.5rem] w-full'>
                        <div className='font-bold text-[0.938rem] leading-[23px] bg-[linear-gradient(#022c43,_#18b0c8)] px-[10px] py-[5px] text-[#ffffff] rounded-tl-[calc(.25rem-1px)] rounded-br-[0] rounded-tr-[calc(.25rem-1px)] rounded-bl-[0]'>
                            Backup Sports Profit
                        </div>
                        <div className='p-[0px flex-auto] w-full border-[1px] border-[#0000002d] bg-[#ffffff] flex items-center justify-center'>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={options}
                            />
                        </div>
                    </div>
                </div>
            </div >
        </div>
    );
}

export default Dashboard;
